import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="smack_solution p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2>Tekrevol's Solution</h2>
            <p>
              As we were able to identify the problem of the audiences and what
              features they needed in a message scheduling and communication app
              like Smackback, it helped us take the idea further and ensure that
              once the user downloads it, he/she doesn’t need to ever worry
              about replying back to text messages in a timely manner ever
              again.
            </p>
            <p>
              Basic apps that offer a very similar functionality to Smackback
              were already available for download on both the Google Play and
              Apple App Store, but they either lacked the many features that we
              believe should have been there or were too dull to ensure that
              users had a lively interaction with them.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 text-center "
          >
            <StaticImage
              src="../../../images/case-studies/smackback/phones.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={943}
              height={855}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
